/**
 * Partners section: live review feed from Judge.me via Lab401 review API.
 * Fetches the latest 20 reviews and replaces the static testimonial slides.
 * Falls back silently to static content on any error.
 *
 * Security: All review content is inserted via textContent (never innerHTML).
 * The API response is treated as untrusted user-generated content.
 */
(function () {
  'use strict';

  var API = 'https://shopify-judgeme-review-feed.lab401.workers.dev/reviews';
  var container = document.querySelector('[data-reviews-container]');
  if (!container) return;

  /* ── Parse time labels from Liquid-rendered JSON ─────────── */
  var labels = {};
  try {
    var el = document.querySelector('[data-review-time-labels]');
    if (el) labels = JSON.parse(el.textContent);
  } catch (e) { /* use defaults */ }

  var lang = (labels.lang || document.documentElement.lang || 'en').toLowerCase().split('-')[0];

  /* ── "Time ago" formatter ────────────────────────────────── */
  // For FR/ES/DE the word order is "ago N unit" (e.g. "il y a 3 jours")
  // For EN/IT it's "N unit ago" (e.g. "3 days ago", "3 giorni fa")
  var prefixLangs = { fr: true, es: true, de: true };

  function timeAgo(isoDate) {
    var now = Date.now();
    var then = new Date(isoDate).getTime();
    var diffSec = Math.max(0, Math.floor((now - then) / 1000));

    var diffMin = Math.floor(diffSec / 60);
    var diffHr = Math.floor(diffMin / 60);
    var diffDay = Math.floor(diffHr / 24);
    var diffWeek = Math.floor(diffDay / 7);
    var diffMonth = Math.floor(diffDay / 30);
    var diffYear = Math.floor(diffDay / 365);

    var ago = labels.ago || 'ago';
    var n, unit;

    if (diffYear >= 1) {
      n = diffYear; unit = diffYear === 1 ? (labels.year || 'year') : (labels.years || 'years');
    } else if (diffMonth >= 1) {
      n = diffMonth; unit = diffMonth === 1 ? (labels.month || 'month') : (labels.months || 'months');
    } else if (diffDay >= 14) {
      n = diffWeek; unit = diffWeek === 1 ? (labels.week || 'week') : (labels.weeks || 'weeks');
    } else if (diffDay >= 7) {
      return labels.last_week || 'last week';
    } else if (diffDay >= 2) {
      n = diffDay; unit = labels.days || 'days';
    } else if (diffDay >= 1) {
      return labels.yesterday || 'yesterday';
    } else if (diffHr >= 1) {
      n = diffHr; unit = diffHr === 1 ? (labels.hour || 'hour') : (labels.hours || 'hours');
    } else if (diffMin >= 1) {
      n = diffMin; unit = diffMin === 1 ? (labels.minute || 'minute') : (labels.minutes || 'minutes');
    } else {
      n = diffSec; unit = diffSec === 1 ? (labels.second || 'second') : (labels.seconds || 'seconds');
    }

    if (prefixLangs[lang]) {
      return ago + ' ' + n + ' ' + unit;
    }
    return n + ' ' + unit + ' ' + ago;
  }

  /* ── Star rating string ──────────────────────────────────── */
  function stars(rating) {
    var s = '';
    for (var i = 0; i < 5; i++) s += (i < rating) ? '\u2605' : '\u2606';
    return s;
  }

  /* ── Mask PII: "First Last" → "First L." ────────────────── */
  function maskName(name) {
    if (!name) return '';
    var parts = name.trim().split(/\s+/);
    if (parts.length < 2) return parts[0];
    return parts[0] + ' ' + parts[parts.length - 1].charAt(0).toUpperCase() + '.';
  }

  /* ── Build a single slide using safe DOM methods ─────────── */
  function buildSlide(review) {
    var slide = document.createElement('div');
    slide.className = 'swiper-slide partners-slide-box';

    var textP = document.createElement('p');
    textP.className = 'partners-slide-text';
    textP.textContent = review.body || '';
    slide.appendChild(textP);

    // After render, check if text exceeds 170px and add truncation class
    requestAnimationFrame(function () {
      if (textP.scrollHeight > 75) {
        textP.classList.add('partners-slide-text-truncated');
      }
    });

    // Product name line (if available)
    if (review.product_title) {
      var productP = document.createElement('p');
      productP.className = 'partners-review-product';
      if (review.product_handle) {
        var productLink = document.createElement('a');
        productLink.href = '/products/' + encodeURIComponent(review.product_handle);
        productLink.target = '_blank';
        productLink.rel = 'noopener';
        productLink.textContent = review.product_title;
        productP.appendChild(productLink);
      } else {
        productP.textContent = review.product_title;
      }
      slide.appendChild(productP);
    }

    var authorP = document.createElement('p');
    authorP.className = 'partners-slide-author';

    var starsSpan = document.createElement('span');
    starsSpan.className = 'partners-review-stars';
    starsSpan.textContent = stars(review.rating);
    authorP.appendChild(starsSpan);

    var dash = document.createTextNode(' \u2014 ');
    authorP.appendChild(dash);

    var nameText = document.createTextNode(
      maskName((review.reviewer && review.reviewer.name) || '')
    );
    authorP.appendChild(nameText);

    var space = document.createTextNode(' ');
    authorP.appendChild(space);

    var dateEm = document.createElement('em');
    dateEm.className = 'partners-review-date';
    dateEm.textContent = timeAgo(review.created_at);
    authorP.appendChild(dateEm);

    slide.appendChild(authorP);
    return slide;
  }

  /* ── Fetch and render ────────────────────────────────────── */
  var url = API + '?lang=' + encodeURIComponent(lang);

  fetch(url)
    .then(function (res) {
      if (!res.ok) throw new Error(res.status);
      return res.json();
    })
    .then(function (data) {
      if (!data.reviews || !data.reviews.length) return; // keep static

      // Clear static slides
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }

      // Build new slides from API data
      for (var i = 0; i < data.reviews.length; i++) {
        container.appendChild(buildSlide(data.reviews[i]));
      }

      // Re-init swiper after content replacement
      var swiperEl = document.getElementById('partners--swiper');
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }
      loadSwiper().then(function () {
        new Swiper('#partners--swiper', {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoplay: { delay: 3000, disableOnInteraction: false },
          speed: 1000
        });
      });
    })
    .catch(function () {
      // Silent fallback — keep static testimonials
    });
})();
